// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider,setPersistence, browserLocalPersistence} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDpFOM8-fWMVws3wo4htdlv-8Q4X2pQQns",
  authDomain: "clientportal-c85af.firebaseapp.com",
  projectId: "clientportal-c85af",
  storageBucket: "clientportal-c85af.appspot.com",
  messagingSenderId: "305654532544",
  appId: "1:305654532544:web:fb1d931e4722c3a59aa025"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Error setting Firebase persistence:", error);
  });
export const db = getFirestore(app);
const provider = new GoogleAuthProvider();

export { auth,provider };